module.exports = "https://qp-assets.quero.com/assets/images/onboarding/payment.svg?e96b4a302faf1e9671f77ab8d4318c38";